import {
  SEND_ERROR_REPORT,
  SEND_ERROR_REPORT_SUCCESS,
  SEND_ERROR_REPORT_ERROR,
} from "../../constants/action-types";

const initialState = {
  data: {},
  emailSettingsRes: {},
  error: "",
  loading: false,
  locale: {},
  res: {},
};

export const errorReportingReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SEND_ERROR_REPORT: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case SEND_ERROR_REPORT_SUCCESS: {
      return {
        ...state,
        res: action.payload,
      };
    }
    case SEND_ERROR_REPORT_ERROR: {
      return {
        ...state,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};
